import { Text } from '@innovationdepartment/proxima-ui';

const BillingPlanPaymentFailed = () => (
  <Text variant="body2" color="red70">
    Payment failed. Please update your payment method.
  </Text>
);

export default BillingPlanPaymentFailed;
